import React, { useState } from 'react';
import Slider from "react-slick";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

// Compents
import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'

const accordionData = [
  {
id:1,
title:"Block ice systems",  
content:"Block ice plants freeze water in large molds using robust refrigeration packages that deliver reliable capacity in harsh ambient and power conditions.These systems are ideal for fish, produce and construction markets where ice is crushed on site and long holding times are required.Typical designs use ammonia-based brine chillers or direct expansion molds, engineered for easy operation and low lifecycle cost."
},

{
id:2,
title:"Flake ice systems",  
content:"Flake ice machines produce thin, free-flowing ice with a large surface area for rapid, gentle cooling of food, seafood, and concrete batches.Using stainless-steel evaporators and efficient ammonia or Freon refrigeration, these systems deliver high daily tonnage with low specific power consumption.Modular designs integrate seamlessly with existing refrigeration plants, automated storage, and dosing systems for fully continuous processes."
},

{
id:3,
title:"Tube ice systems",  
content:"Tube ice generators produce clear, hard cylindrical ice that melts slowly and looks premium, making it ideal for beverages, packaged ice, and retail applications.Vertical tube evaporators with hot-gas defrost ensure consistent ice size, stable operation, and 24/7 production capability.Systems can be supplied as standalone packages or integrated with central ammonia/HFC plants, with optimized controls for energy and water efficiency."
},

{
id:4,
title:"Plate / slice ice systems",  
content:"Plate ice systems form ice on flat stainless plates and harvest it in uniform pieces, combining high hygiene with reliable, continuous operation.The plate evaporator works as a high-efficiency heat exchanger, allowing higher suction temperatures and lower operating costs than many traditional systems.These units are well suited for food processing, poultry, and logistics facilities that require clean ice and easy CIP-friendly layouts."
},

{
id:5,
title:"Slurry ice systems",  
content:"Slurry ice plants generate a pumpable mixture of fine ice crystals and chilled water or brine, providing ultra-fast, uniform heat removal from product.Scraped-surface or plate-type evaporators coupled with ammonia or CO₂ refrigeration create small crystal sizes that gently surround fish or food surfaces.These systems integrate with storage tanks, distribution pumps, and process controls to deliver precise temperature management across the cold chain."
},

{
id:6,
title:"Cube / commercial ice systems",  
content:"Industrial cube and nugget ice systems supply clear, hygienic ice for hospitality, quick-service restaurants, and packaged ice brands.Direct-expansion plate or grid evaporators with hot-gas harvest deliver consistent cube geometry and fast recovery after peak demand.Compact, air- or water-cooled packages are designed for easy installation, low maintenance, and integration with filtration and sanitation solutions."
}
]

function Airpurger() {
 
    useGaspAnimations()

 const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
          {/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Air Purger</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Air Purger</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
         <ProductFilter/>
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeLeft">
                            {/* <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider> */}
                               <img src="assets/images/OurProducts/Container-Plant.webp" alt="Awesome Image"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className="title sec-title">
                                    <h1 className='title-anim'><span>ICE Production systems</span></h1>
                                </div>
                                <div className="text">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                     Ice for commercial and industrial use is produced mainly as block, flake, tube, plate/slice, cube and slurry, and almost all modern plants use mechanical vapour-compression systems with ammonia or HFCs/HCs, sized to the required evaporation temperature and capacity. The refrigeration side is essentially a chiller (direct or indirect expansion) designed around the ice-making surface (cans, drum, plates, tubes, etc.) and the desired ice temperature
                                    </p>
                                     <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                    {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content bdFadeUp">
                        <div className="col-md-7">
                            <div className="text-holder">
                                <div className="title">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul>
                                            {accordionData.map(({title}) => (
                                        <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>{title}</li>
                                       ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5">
                             <Slider {...settings}>
                                <img src="assets/images/OurProducts/Ice/01.webp" alt="Awesome Image"/>
                                <img src="assets/images/OurProducts/Ice/02.webp" alt="Awesome Image"/>
                            </Slider>
                        </div>
                    </div>
                    {/* <!--End middle content--> */}
                    {/* <!--Start bottom content--> */}
                      <div className="row bottom-content bdFadeRight">
                        <div className="col-md-12">
                            <div className="title">
                                    <h2>Sub-category Descriptions</h2>
                                </div>
                            <div className="accordion-box">
                                {accordionData.map(({ id, title, content }) => (
                                <>
                                 {/* <!--Start single accordion box--> */}
                                <div className="accordion accordion-block" key={id}>
                                    <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                    {openSections[id] && (
                                    <div className="accord-content collapsed">
                                        <p>
                                        {content}
                                        </p>
                                    </div>
                                    )}
                                </div>
                                 {/* <!--End single accordion box-->  */}
                                </>
                                ))}
                        </div>
                    </div>
                    </div>
                    {/* <!--End bottom content--> */}
                    {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
                </div>
            </div>
      
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Airpurger;


